import { environmentConfig } from "@src/appV2/environment";
import { logApiFailureEvent } from "@src/lib/analytics";
import request from "superagent";

import { Response } from "../../utils/response";
import { getAuthHeader } from "../superagent";

export interface RequestLastMinuteShiftsOptions {
  getCountOnly?: boolean;
}

export const fetchLastMinuteShifts = async (
  options: RequestLastMinuteShiftsOptions
): Promise<Response> => {
  return await request
    .get(`${environmentConfig.REACT_APP_BASE_API_URL}/lastMinuteShifts`)
    .retry(1, (err) => {
      if (!err) {
        return false;
      }
      return true;
    })
    .set(await getAuthHeader())
    .query(options)
    .then(({ body }) => body);
};

export const instantPayStatus = async () => {
  try {
    const { body } = await request
      .get(`${environmentConfig.REACT_APP_BASE_API_URL}/agentprofile/instant-pay-status`)
      .retry(1, (err) => {
        if (!err) {
          return false;
        }
        return true;
      })
      .set(await getAuthHeader());
    return body;
  } catch (error) {
    logApiFailureEvent(error);
  }
};
